import { useRef } from 'react';
import loadable from '@utils/loadable';

import { useSelector } from 'react-redux';
import withMetatag from '../../../decorators/metadataDecorators/metatagsTitleDecorator';
import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const BrokersTopSection = loadable(() => import('./BrokersComponents/BrokersTopSection'));
const BrokersTrustedBySection = loadable(() => import('../LearnMoreComponents/MainLearnMore/LearnMoreSections/TrustedSection'));
const BrokersBecomeSection = loadable(() => import('./BrokersComponents/BrokersBecomeSection'));
const BrokersDataSection = loadable(() => import('./BrokersComponents/BrokersDataSection'));
const BrokersFeaturesSection = loadable(() => import('./BrokersComponents/BrokersFeaturesSection'));
const BrokersLiveSection = loadable(() => import('./BrokersComponents/BrokersLiveSection'));
const BrokersBuildSection = loadable(() => import('./BrokersComponents/BrokersBuildSection'));
const BrokersTrackSection = loadable(() => import('../LearnMoreComponents/MainLearnMore/LearnMoreSections/NewsCoverageSection'));
const BrokersSolutionSection = loadable(() => import('./BrokersComponents/BrokersSolutionSection'));
const BrokersPricingSection = loadable(() => import('./BrokersComponents/BrokersPricingSection'));
const BrokersContactSection = loadable(() => import('./BrokersComponents/BrokersContactSection'));

function BrokersLanding() {
  const contactForm = useRef(null);

  const goToContactForm = () => {
    contactForm.current.scrollIntoView({ behavior: 'smooth' });
  };

  const { searchBarActive } = useSelector((state) => state.searchReducers);

  return (
    <div className={Styles['brokers-wrapper']}>
      { searchBarActive && <div className={Styles.overlay} /> }
      <BrokersTopSection
        goToContactForm={goToContactForm}
      />
      <BrokersTrustedBySection
        brokers
      />
      <BrokersBecomeSection />
      <BrokersDataSection />
      <BrokersFeaturesSection />
      <BrokersLiveSection />
      <BrokersBuildSection />
      <BrokersTrackSection />
      <BrokersSolutionSection />
      <BrokersPricingSection
        goToContactForm={goToContactForm}
      />
      <BrokersContactSection
        ref={contactForm}
      />
    </div>
  );
}

export default withComponentName(withMetatag(BrokersLanding, 'segments/brokers'));
